import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'rounddecimal'})
export class RounddecimalPipe implements PipeTransform {
    transform(value: number, num: number): any {
        if (!value) return 0;
        return value.toFixed(num);
    }
}

@Pipe({name: 'roundpercent'})
export class RoundpercentPipe implements PipeTransform {
  transform(value: number, num: number): any {
    if (!value) { return '0%'; }
    value = value * 100;
    const roundvalue = Math.round(value);
    if (value >= 1) {
      return `${roundvalue}%`;
    } else {
      return '< 1%';
    }
  }
}
